import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import FortuneCards from '../Components/Awards/FortuneCards'
import TrustedLeaderSection from '../Components/Awards/TrustedLeaderSection'
import GreatPlaceToWorkSection from '../Components/Awards/GreatPlaceToWorkSection'
import IndustryRecognitionSection from '../Components/Awards/IndustryRecognitionSection'
import { Helmet } from "react-helmet-async";
function Awards() {
    return (
        <div>
            <Helmet>
    <title>
        Awards & Recognition | Mobikode
    </title>

    <meta
        name="description"
        content="Explore Mobikode's awards, industry recognition, workplace achievements, and trusted leadership milestones that reflect our commitment to technology, innovation, and excellence."
    />

    <meta
        name="keywords"
        content="Mobikode Awards, Mobikode Recognition, Awards and Recognition, Industry Recognition, Technology Awards, IT Company Awards, Digital Transformation Awards, Business Excellence Awards, Workplace Recognition, Great Place to Work, Technology Excellence, Mobikode Achievements"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/awards"
    />

    <meta
        property="og:title"
        content="Awards & Recognition | Mobikode"
    />

    <meta
        property="og:description"
        content="Discover Mobikode's awards, industry recognition, workplace achievements, and milestones that showcase our commitment to technology, innovation, and excellence."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/awards"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/awards/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Awards & Recognition | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Learn about Mobikode's awards, industry recognition, workplace achievements, and technology excellence."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/awards/bg1.png"
    />
</Helmet>
            <WhoHero
                title="Awards & Recognition"
                text="Technology. Transformation. Trust."
                imgData="/assets/awards/bg1.png"
            />
            <FortuneCards />
            <TrustedLeaderSection />
            <GreatPlaceToWorkSection />
            <IndustryRecognitionSection />
        </div>
    )
}

export default Awards
